import { CategoriaInvitado, TipoEvento } from "./TipoEvento"

export interface IDetallePago {
  id?: number
  formaDePago: FormaDePago
  monto: number
}

export interface IDatosTransferencia {
  transferenciaNombre?: string
  transferenciaApellido?: string
  transferenciaDni?: string
  transferenciaTelefono?: string
  transferenciaEntidadBancaria?: string
}

export interface IRecibo {
  id: number
  numero: string
  isAnulado: boolean
  fechaAnulacion: string
  motivoAnulacion: string
  usuarioAnulacion?: string
  tarjetasAdulto: number
  tarjetasMenor: number
  tarjetasBaile?: number
  mesaDulce?: number
  posCena?: number
  barra?: number
  seniaDePago?: boolean
  detallesPago?: IDetallePago[]
  fecha: string
  totalRecibo: bigint
  idEgresado: string
  usuarioCarga?: string
  transferenciaNombre?: string
  transferenciaApellido?: string
  transferenciaDni?: string
  transferenciaTelefono?: string
  transferenciaEntidadBancaria?: string
}

export interface IReciboRequest extends IDatosTransferencia {
  tarjetasAdulto: number
  tarjetasMenor: number
  tarjetasBaile?: number
  mesaDulce?: number
  posCena?: number
  barra?: number
  seniaDePago?: boolean
  detallesPago: IDetallePago[]
  totalRecibo: number
  idEgresado: number
  usuarioCarga?: string
}

export interface IReciboEventoRequest extends IDatosTransferencia {
  tarjetasAdulto: number
  tarjetasMenor: number
  tarjetasBaile?: number
  mesaDulce?: number
  posCena?: number
  barra?: number
  seniaDePago?: boolean
  detallesPago: IDetallePago[]
  totalRecibo: number
  eventoId: number
  usuarioCarga?: string
}

export const USUARIOS_CARGA = ["Usuario A", "Usuario B", "Usuario C"] as const
export type UsuarioCarga = (typeof USUARIOS_CARGA)[number]

export interface RecibosModalProps {
  show: boolean
  handleClose: () => void
  handleReciboAdd: (recibo: IReciboRequest) => void
  idEgresado: string
  idEvento: string
  tipoEvento?: TipoEvento
}

export interface RecibosEventoModalProps {
  show: boolean
  handleClose: () => void
  handleReciboEventoAdd: (recibo: IReciboEventoRequest) => Promise<void>
  idEvento: string
  tipoEvento?: TipoEvento
  nombreEvento?: string
  telefonoEvento?: string
  nombreClienteEvento?: string
}

export interface AddRecibosModalProps {
  show: boolean
  handleClose: () => void
  onReciboCreado: (recibo: IReciboRequest) => void
  idEgresado: number
  usuarioCarga: string
  tipoEvento?: TipoEvento
  categoria?: CategoriaInvitado
}

export interface AddReciboEventoModalProps {
  show: boolean
  handleClose: () => void
  onReciboCreado: (recibo: IReciboEventoRequest) => void
  eventoId: number
  usuarioCarga: string
  tipoEvento?: TipoEvento
}

export enum FormaDePago {
  TRANSFERENCIA = "TRANSFERENCIA",
  EFECTIVO = "EFECTIVO",
  CREDITO = "CREDITO",
  DEBITO = "DEBITO",
}

export const FormaDePagoLabels: Record<FormaDePago, string> = {
  [FormaDePago.TRANSFERENCIA]: "Transferencia",
  [FormaDePago.EFECTIVO]: "Efectivo",
  [FormaDePago.CREDITO]: "Crédito",
  [FormaDePago.DEBITO]: "Débito",
}
